import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(VueResource)
Vue.use(Vuex)
/*
const snapshotPlugin = store => {
    let prevState = _.cloneDeep(store.state)
    store.subscribe((mutation, state) => {
        let nextState = _.cloneDeep(state)

        // сравнение prevState и nextState...
        console.log(mutation)

        // сохранение состояния для следующей мутации
        prevState = nextState
    })
}
*/

/*
function errorHandler(data){
    if(data.errors.indexOf('auth') != -1 && data.location){
        window.location.href = data.location.replace(/url_redirect_url/i, encodeURIComponent(window.location.href))
    }
}
*/

function showError(data){
    if(typeof data == "string")
        data = {
            error: data
        }
    let err = data.error;
    let args = [err];
    if(NODE_ENV == 'development' || NODE_ENV == 'test')
        alert(err)

    if(NODE_ENV == 'development' || NODE_ENV == 'test'){
        args.unshift("(Error code: " + data.code + ") ");
        args.push("\n\rFile: " + data.file + " " + data.line);
        args.push(data.trace);
    }

    console.error.apply(document, args);
}
function errorHandler(data){
    if(typeof data == "object" && typeof data.errors == "object" && data.errors.indexOf('auth') != -1 && data.location){
        return window.location.href = data.location.replace(/url_redirect_url/i, encodeURIComponent(window.location.href))
    }
    return showError(data)
}
function responseHandler(resp){
    if(resp.body.success){
        return resp.body.data
    }else(
        errorHandler(resp.body.data)
    )
}
function httpErrorHandler(resp){
    showError("HTTP error: " + resp.status + " " + resp.statusText + " " + resp.body.data )
}

const emptyReport = {
    referral_number: null,
    is_dbs_tariff: false,
    is_repaired_by_ws: false,
    sent_at: null,
    comment: null,
    has_two_keys: false,
    without_price: false,
    is_condition_report: false,
    has_to_set_wheels: false,
    is_service_checked: false,
    report_role: null,
    service_history: [[null,null]],
    service_history_description: null,
    contact_name: null,
    contact_email: null,
    contact_phone: null,
    firma: null,
    id_parent_report: null,
    id_client: null,
    id_car: null,
    car_mileage: null,
    car_market: null,
    id_report_type: 1,
    id_user: 1,
    id: null,
    damage_description: null
}

const store = new Vuex.Store({
    //plugins: [snapshotPlugin],
    watch: {},
    state: {
        archive: {
            reports: [],
            pagesCount: 1,
            filter: {
                search: "",
                searchFirm: "",
                perPage: 50,
                page: 1,
                startDate: '',
                endDate: '',
                onlyRegularReports: 1,
                onlyEuropcarReports: 0,
                onlyEuropcarReportsDansk: 0
            }
        },
        reports: [],
        clients: [],
        report: {},
        report_items: [],
        report_items_replies: [],
        car: {},
        reports_logs: [],
        line_item_descriptions: [
            {
                description: 'Oppstartskostnad',
                description_en: 'Start up-cost',
                description_da: 'Opstartsomkostninger',
                description_sv: 'Startavgift',
                category: 'start cost'
            },
            {
                description: 'Verksted materiell',
                description_en: 'Garage materials',
                description_da: 'Værkstedsudstyr',
                description_sv: 'Verkstadens utrustning',
                category: 'materials'
            },
            {
                description: 'Demontering/Montering',
                description_en: 'Dismounting/mounting',
                description_da: 'Demontering/Montering',
                description_sv: 'Demontering / Montering',
                category: 'dismounting / mounting'
            },
            {
                description: 'Delekostnad',
                description_en: 'Part-cost',
                description_da: 'Delvis omkostning',
                description_sv: 'Delkostnad',
                category: 'parts cost'
            },
            {
                description: 'Flate-retting',
                description_en: 'Straightening',
                description_da: 'Flad-korrektion',
                description_sv: 'Platt-korrigering',
                category: 'straightening'
            },
            {
                description: 'Lakkmateriell',
                description_en: 'Paint-materials',
                description_da: 'Lak materiale',
                description_sv: 'Lack material',
                category: 'paint materials'
            },
            {
                description: 'Lakkering',
                description_en: 'Paint-work',
                description_da: 'Lakering',
                description_sv: 'Lackering',
                category: 'paint'
            },
            {
                description: 'Kalibrering',
                description_en: 'Calibration',
                description_da: 'Kalibrering',
                description_sv: 'Kalibrering',
                category: 'calibration'
            },
            {
                description: 'Diagnose',
                description_en: 'Diagnostics',
                description_da: 'Diagnose',
                description_sv: 'Diagnos',
                category: 'diagnostics'
            },
            {
                description: 'Vask og eller Polering',
                description_en: 'Wash / Polish',
                description_da: 'Vask og eller poler',
                description_sv: 'Tvätta och eller polera',
                category: 'wash / polish'
            },
            {
                description: 'Miljøgebyr',
                description_en: 'Enviromental fee',
                description_da: 'Miljøgebyr',
                description_sv: 'Miljöavgift',
                category: 'enviromental fee'
            },
            {
                description: 'Reparasjonskostnad',
                description_en: 'Repair-cost',
                description_da: 'Reparationsomkostninger',
                description_sv: 'Reparationskostnad',
                category: 'repair cost'
            },
            {
                description: 'Reparasjonstid',
                description_en: 'Repair-time',
                description_da: 'Reparationstid',
                description_sv: 'Reparationstid',
                category: 'repair time'
            },
            {
                description: 'Takseringskostnad',
                description_en: 'Cost for damage/evaluation report',
                description_da: 'Vurderingsomkostninger',
                description_sv: 'Värderingskostnad',
                category: 'report cost'
            },
            {
                description: 'Lakkering-arbeid',
                description_en: 'Paint cost',
                description_da: 'Lakering arbejde',
                description_sv: 'Lackeringsarbete',
                category: 'paint cost'
            },
            {
                description: 'Smart-repair',
                description_en: 'Smart-repair',
                description_da: 'Smart-reparation',
                description_sv: 'Smart-reparation',
                category: 'smart-repair'
            }
        ]
    },
    getters: {
        reports_logs(state){
            return state.reports_logs
        },
        archive(state){
            return state.archive
        },
        reports(state){
            return state.archive.reports
        },
        clients(state){
            return state.clients
        },
        report(state){
            return state.report
        },
        report_items(state){
            return state.report_items
        },
        report_items_replies(state){
            return state.report_items_replies
        },
        car(state){
            return state.car
        },
        line_item_descriptions(state){
            return state.line_item_descriptions
        }
    },
    mutations: {
        set(state, { type, val }){
            state[type] = val
        },
        setItem(state, {type, item, val}){
            if(typeof state[type] == 'object')
                state[type][item] = val
        },
        new(state, {report}){
            let newReport = JSON.parse(JSON.stringify(emptyReport));
            console.log(newReport);
            if(report)
                Object.assign(newReport, report);
            state['report'] = newReport;
            state['report_items'] = [];
            state['car'] = {};
        },
        clearFilterArchive(state){
            state.archive.filter.page = 1
            state.archive.filter.search = ''
            state.archive.filter.searchFirm = ''
            state.archive.filter.startDate = ''
            state.archive.filter.endDate = ''
        },
        applyReport(state, data){
            console.log('applyReport', data);
            var report = data.report;
            report.is_service_checked = parseInt(report.is_service_checked) ? true : false
            report.without_price = parseInt(report.without_price) ? true : false
            report.has_two_keys = parseInt(report.has_two_keys) ? true : false
            report.has_to_set_wheels = parseInt(report.has_to_set_wheels) ? true : false
            report.is_repaired_by_ws = parseInt(report.is_repaired_by_ws) ? true : false
            report.is_dbs_tariff = parseInt(report.is_dbs_tariff) ? true : false

            report.report_fixed_cost = parseFloat(report.report_fixed_cost) ? parseFloat(report.report_fixed_cost) : 0 ;

            report.is_condition_report = parseInt(report.is_condition_report) ? true : false

            if(!report.service_history){
                report.service_history = [[null,null]]
            } else if(typeof report.service_history != 'object'){
                report.service_history = JSON.parse(report.service_history.replace(/\\/g,''));
            }

            state.report = data.report
            state.car = data.car
            state.report_items = data.report_items
            state.report_items_replies = data.report_items_replies
        }
    },
    actions: {
        getReports({ commit }, data=[]){
            let url = '/wp-admin/admin-ajax.php?action=mps_pt_get_reports'

            let params = {}
            Object.keys(data).forEach((val, idx)=>{
                if(data[val])
                    params[val] = data[val]
            })
            if(Object.keys(params).length){
                params = new URLSearchParams(params).toString()
                url += '&' + params
            }

            return Vue.http.get(url).then(resp => {
                if(resp.body.success){
                    commit('setItem', {type: 'archive', item: 'reports', val: resp.body.data.reports})
                    commit('setItem', {type: 'archive', item: 'pagesCount', val: resp.body.data.reportsPagesCount})
                }else{
                    errorHandler(resp.body.data)
                }
            })
        },
        getReportsLogs({ commit, state }, data){
            const url = '/wp-admin/admin-ajax.php?action=mps_pt_get_reports_logs'
            let len = state.reports_logs.length
            let lastLogId = null
            if( len )
                lastLogId = state.reports_logs[ len - 1 ].id
            let params = {}
            if( lastLogId )
                params.last_log_id = lastLogId
            if( data.search )
                params.search = data.search
            if( data.license )
                params.license = data.license

            return Vue.http.post(url, params, { emulateJSON: true }).then(resp => {
                if(resp.body.success) {
                    let logs = resp.body.data;//state.reports_logs.concat( resp.body.data )
                    commit('set', {type: 'reports_logs', val: logs})
                } else {
                    errorHandler(resp.body.data)
                }
            })
        },
        getClients({ commit, state }){
            if(state.clients.length)
                return;
            const url = '/wp-admin/admin-ajax.php?action=mps_pt_get_clients'
            return Vue.http.get(url).then(resp => {
                if(resp.body.success) //self.clients = resp.body.data
                    commit('set', {type: 'clients', val: resp.body.data})
                },
                httpErrorHandler
            )
        },
        getReport({commit,state,dispatch}, id){
                const url = '/wp-admin/admin-ajax.php?action=mps_pt_get_report&id=' + id
                return Vue.http.get(url).then(resp => {
                    if(resp.body.success){
                        commit('applyReport', resp.body.data)
                    }else{
                        errorHandler(resp.body.data)
                    }
                },
                httpErrorHandler
        )},
        getReportByCode({commit,state,dispatch}, code){
            const url = '/wp-admin/admin-ajax.php?action=mps_pt_get_report&code=' + code
            return Vue.http.get(url).then(resp => {
                if(resp.body.success){
                    commit('applyReport', resp.body.data)
                }else{
                    errorHandler( resp.body.data )
                }
            },
            httpErrorHandler
        )},
        getLatestReport({commit,state,dispatch}, id_car){
            const url = '/wp-admin/admin-ajax.php?action=mps_pt_get_latest_report&id_car=' + id_car
            return Vue.http.get(url).then(
                responseHandler,
                httpErrorHandler
            );
        },

        setReportClient({commit,state}, id){
            commit('setItem', {type: 'report', item: 'id_client', val: id})
        },
        sendReport({commit, state}){
            var report = {};
            Object.keys(state.report).forEach(function (k) {
                report[k] = state.report[k];
            });

            report.is_service_checked = report.is_service_checked ? 1 : 0
            report.has_two_keys = report.has_two_keys ? 1 : 0
            report.has_to_set_wheels = report.has_to_set_wheels ? 1 : 0
            report.is_repaired_by_ws = report.is_repaired_by_ws ? 1 : 0
            report.is_dbs_tariff = report.is_dbs_tariff ? 1 : 0

            report.is_condition_report = report.is_condition_report ? 1 : 0
            report.without_price = report.without_price ? 1 : 0

            report.service_history = report.service_history.filter((v)=>{
                return v[0] || v[1];
            })

            if(!report.service_history.length) {
                report.service_history = null
            }

            if (!report.damage_description || !report.damage_description.length) {
                report.damage_description = null
            }

            console.log(report)

            return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_save_report', {report: report},{emulateJSON: true}).then(
                responseHandler,
                httpErrorHandler
            );
        },
        confirmReport({commit, state}, {status, code}){
            return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_confirm_report', {status: status, code: code},{emulateJSON: true}).then(function (response) {
                if(!response.body.data.updated)
                    return false;
                state.report.confirmation = response.body.data.report.confirmation
                state.report.confirmed_at = response.body.data.report.confirmed_at

                return state.report.confirmation
            }, httpErrorHandler);
        },
        sendAnswers({commit, state}, answers){
            var promisesGroup = 'sendAnswers'

            var filterAnswerFields = function(answer){
                var data = {}
                Object.keys(answer).forEach((prop, idx) => {
                    if(['id', 'id_report','id_report_item','id_report_category','state','images','description','condition_value','extra_value','estimate','lineitems'].indexOf(prop) != -1)
                        data[prop] = answer[prop]
                })
                //console.log("data");
                //console.log(data);
                return data
            }
            
            var prepareAnswers = function(answers){
                var data = []
                answers.forEach((answer, idx) => {
                    if(answer.image_file){
                        formData.append('image', answer.image_file)
                        delete answer.image_file
                    }
                    data[idx] = filterAnswerFields(answer)
                })
                return data
            }

            var vuePromise = function(answers) {
                var formData = new FormData()
                
                var data = []
                answers.forEach((answer, idx) => {
                    if(answer.image_file){
                        let id_report_item = answer.id_report_item ? answer.id_report_item : "";
                        let id_answer = answer.id ? answer.id : "";
                        formData.append(`image-${answer.id_report}-${id_report_item}-${id_answer}`, answer.image_file)
                        delete answer.image_file
                    }
                    data[idx] = filterAnswerFields(answer)
                })

                formData.append('answers', JSON.stringify(data))

                return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_save_answers', formData).then(function (response) {
                    answers.forEach((answer, idx) => {
                        if (!answer.id && response.body.data[idx]){
                            answer.id = response.body.data[idx]['id']
                        }

                        if (response.body.data[idx]['images']){
                            answer.images = response.body.data[idx]['images']
                        }

                        // for each lineitem needed to check for new lineitem id
                        var itemLines = response.body.data[idx].itemlines;

                        answer.lineitems.forEach((lineitem, lidx) => {
                            if (!lineitem.id && itemLines){
                                lineitem.id = itemLines[lidx];
                            }
                        })
                    })

                    return answers

                }, httpErrorHandler)
            }

            if(window[promisesGroup]){
                window[promisesGroup] = window[promisesGroup].then(vuePromise.bind(this, answers))
            }else{
                window[promisesGroup] = vuePromise(answers)
            }
            
            return window[promisesGroup]
        },
        sendAnswer({commit, state}, answer){
            var promisesGroup = 'sendAnswer' + answer.id_report + '.' + answer.id_report_item

            var filterAnswerFields = function(answer){
                var data = {}
                Object.keys(answer).forEach((prop, idx) => {
                    if(['id', 'id_report','id_report_item','id_report_category','state','description','condition_value','extra_value','estimate','lineitems'].indexOf(prop) != -1)
                        data[prop] = answer[prop]
                })
                return data
            }

            var vuePromise = function(answer) {
                var formData = new FormData()
                if(answer.image_file){
                    formData.append(`image-${answer.id_report}-${answer.id_report_item}`, answer.image_file)
                    delete answer.image_file
                }
                var data = {}
                data = filterAnswerFields(answer)
                formData.append('answer', JSON.stringify(data))

                return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_save_answer', formData).then(function (response) {
                    if (!answer.id){
                        answer.id = response.body.data
                        delete window[promisesGroup]
                    }

                    return answer
                }, httpErrorHandler)
            }


            if(!answer.id)
                if(window[promisesGroup]){
                    window[promisesGroup] = window[promisesGroup].then(vuePromise)
                }else{
                    window[promisesGroup] = vuePromise(answer)
                }
            return window[promisesGroup] ? window[promisesGroup] : vuePromise(answer)
        },
        updateAnswers({commit, state}, data){
            return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_update_answers',
                {
                    reportId: data.reportId,
                    categoryId: data.categoryId
                },
                {   emulateJSON: true   }
            ).then(
                responseHandler,
                httpErrorHandler
            );
        },
        rotateImage({commit, state}, data){
            return Vue.http.post('/wp-admin/admin-ajax.php?action=at_rotate_image', data, { emulateJSON: true }).then(
                responseHandler,
                httpErrorHandler
            )
        },
        sendPdfReport({commit, state}, {id, type, recipients}){
            return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_send_pdf_report',
                {
                    reportId: id,
                    recipientType: type,
                    recipients: recipients
                },
                {   emulateJSON: true   }
            ).then(function (response) {
                    if(response.body.data.sent_at)
                        commit('setItem', {type: 'report', item: 'sent_at', val: response.body.data.sent_at})
                    return response.body.data.sent_at
                },
                httpErrorHandler
            );
        },
        sendApiReport({commit, state}, {id, status, status_description}){
            return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_send_api_report',
                {
                    reportId: id,
                    status: status,
                    statusDescription: status_description
                },
                {   emulateJSON: true   }
            ).then(function (response) {
                    if(response.body.data.sent_at)
                        commit('setItem', {type: 'report', item: 'sent_at', val: response.body.data.sent_at})
                    return response.body.data.sent_at
                },
                httpErrorHandler
            );
        },
        createClientReport({commit, state}, reportId){
            return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_create_client_report',
                {
                    reportId: reportId
                },
                {   emulateJSON: true   }
            ).then(
                responseHandler,
                httpErrorHandler
            );
        },
        copyAldReport({commit, state}, reportId){
            return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_copy_ald_report',
                {
                    reportId: reportId
                },
                {   emulateJSON: true   }
            ).then(
                responseHandler,
                httpErrorHandler
            );
        },
        sendApiReportTest({commit, state}, {file}){
            console.log(file);
            var formData = new FormData();
            formData.append("car_id", "aa 43762");
            formData.append("date", "2019-06-19 11:30:54");
            formData.append("contact_company", "Sixt Norway");
            formData.append("contact_email", "gardermoen@sixt.no");
            formData.append("contact_name", "Oslo Lufthavn Gardermoen ");
            formData.append("contact_phone", "74 82 29 90 ");
            formData.append("mileage", 1000);
            formData.append("service_history", JSON.stringify([["2019-11-11",111]]));
            formData.append("language", "english");
            formData.append("description_1", "Description 1");
            formData.append("description_1_comment", "Description comment 1");
            formData.append("description_2", "Description 2");
            formData.append("image_1_1", file);
            formData.append("image_1_2", file);
            formData.append("image_2_1", file);

            return Vue.http.post('/wp-json/autotaksering/reports/new/', formData, {
                headers: {
                    Authorization: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvYXV0b3Rha3NlcmluZy5zdGFnaW5nLndwZW5naW5lLmNvbSIsImlhdCI6MTU4NTIyMjE3MCwibmJmIjoxNTg1MjIyMTcwLCJleHAiOjE1ODU4MjY5NzAsImRhdGEiOnsidXNlciI6eyJpZCI6IjQ0In19fQ.L_KaU2Rs3YsCHDibQf1YxGLRspr50iPbNCFstyWAyRI"
                }
            }).then(
                responseHandler,
                httpErrorHandler
            );
        },
        getDepartment({commit,state,dispatch}, id){
            const url = '/wp-admin/admin-ajax.php?action=mps_pt_get_department&id=' + id
            return Vue.http.get(url).then(resp => {
                if(resp.body.success){
                    return resp.body.data
                }else{
                    errorHandler(resp.body.data)
                }
            },
            httpErrorHandler
        )},
        sendDepartment({commit, state}, data){
            var department = {};
            Object.keys(data).forEach(function (k) {
                department[k] = data[k];
            });

            return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_save_department', {department: department},{emulateJSON: true}).then(
                responseHandler,
                httpErrorHandler
            );
        },
        /*
        deleteDepartment({commit, state}, id){
            if(!id)
                return false;
            return Vue.http.post('/wp-admin/admin-ajax.php?action=mps_pt_delete_department', {id: id},{emulateJSON: true}).then(
                responseHandler,
                httpErrorHandler
            );
        },
        */
        getDepartments({ commit }){
            let url = '/wp-admin/admin-ajax.php?action=mps_pt_get_departments';
            return Vue.http.get(url).then(resp => {
                if(resp.body.success){
                    return resp.body.data
                }else{
                    errorHandler(resp.body.data)
                }
            })
        },
        getLocFromCloudflare(){
            let url = 'https://www.cloudflare.com/cdn-cgi/trace';
            return Vue.http.get(url).then(resp => {

                if (200 === resp.status && resp.body) {
                    var data = resp.body;
                    data = data.trim().split('\n').reduce(function(obj, pair) {
                        pair = pair.split('=');
                        return obj[pair[0]] = pair[1], obj;
                    }, {});

                    if (data.loc) {
                        return data.loc;
                    }
                }

            })
        },
        /*
        sendRequest(data, files) {
            var url = '';
            if(data.request.id)
                url = `/wp-admin/admin-ajax.php?action=mps_opq_update_request`;
            else
                url = `/wp-admin/admin-ajax.php?action=mps_opq_new_request`;

            var formData = new FormData();
            files.forEach(function(item, i, arr) {
                if(item.file) formData.append("files[" + i + "]", item.file);
            });
            formData.append('json_data', JSON.stringify(data));
            return Vue.http.post(url, formData).then(
                this.responseHandler.bind(this),
                this.httpErrorHandler.bind(this)
            )
        }
         */
    }
})

export default store


// WEBPACK FOOTER //
// ./reports/assets/src/store/index.js